module.exports = __webpack_public_path__ + "img/787fc6e.svg";